import { type SetLocationsProps, type Location } from 'src/types'

const setLocations = (dispatch: (arg0: SetLocationsProps) => void, locations: Record<string, Location>) => {
  dispatch({
    type: 'SET_LOCATIONS',
    locations
  })
}

export {
  setLocations
}
